import type{
  SecurityPosture,UserRow,PasskeyRow,VaultRow,AccessRow,SessionRow,
  RecoveryRow,JitRequest,JitGrant,AuditRow,PolicyRow,SettingRow,AuthorityStatus
}from"./types";
type R=Record<string,unknown>;
const rec=(v:unknown):R=>v&&typeof v==="object"&&!Array.isArray(v)?v as R:{};
const list=(v:unknown,key:string):unknown[]=>{const r=rec(v);return Array.isArray(r[key])?r[key] as unknown[]:[]};
const s=(r:R,k:string,d="")=>typeof r[k]==="string"?String(r[k]):d;
const n=(r:R,k:string,d=0)=>typeof r[k]==="number"?Number(r[k]):d;
const b=(r:R,k:string,d=false)=>typeof r[k]==="boolean"?Boolean(r[k]):d;
const str=(r:R,k:string):string|null=>typeof r[k]==="string"?String(r[k]):null;

export function posture(v:unknown):SecurityPosture{
  const r=rec(rec(v).posture);
  return{
    score:n(r,"score"),health:s(r,"health","UNKNOWN"),user_count:n(r,"user_count"),
    active_passkeys:n(r,"active_passkeys"),org_vault_count:n(r,"org_vault_count"),
    pending_requests:n(r,"pending_requests"),active_jit_grants:n(r,"active_jit_grants"),
    warning_count:n(r,"warning_count"),unlock_capable_passkeys:n(r,"unlock_capable_passkeys"),
    subjects_below_two_unlock:n(r,"subjects_below_two_unlock"),
    subjects_single_trust_group:n(r,"subjects_single_trust_group")
  };
}
export const users=(v:unknown):UserRow[]=>list(v,"users").map(x=>{const r=rec(x);return{
  subject_id:s(r,"subject_id"),display_name:s(r,"display_name","Unknown user"),
  organization_role:s(r,"organization_role","—"),static_system_level:s(r,"static_system_level","—"),
  effective_system_level:s(r,"effective_system_level","—"),active_passkeys:n(r,"active_passkeys"),
  unlock_passkeys:n(r,"unlock_passkeys"),trust_groups:n(r,"trust_groups"),wrapping_key_ready:b(r,"wrapping_key_ready")
}});
export const passkeys=(v:unknown):PasskeyRow[]=>list(v,"passkeys").map((x,i)=>{const r=rec(x);return{
  id:s(r,"id",`passkey-${i}`),subject_name:s(r,"subject_name","Unknown user"),label:s(r,"label","Passkey"),
  trust_group:s(r,"trust_group","unclassified"),device_type:s(r,"device_type","Unknown"),
  backed_up:b(r,"backed_up"),unlock_capable:b(r,"unlock_capable"),status:s(r,"status","UNKNOWN")
}});
export const vaults=(v:unknown):VaultRow[]=>list(v,"vaults").map((x,i)=>{const r=rec(x);return{
  id:s(r,"id",s(r,"vault_id",`vault-${i}`)),vault_kind:s(r,"vault_kind","Organization"),
  status:s(r,"status","UNKNOWN"),current_subject_permissions:r.current_subject_permissions as number|string??"—",
  accessible:b(r,"accessible")
}});
export const access=(v:unknown):AccessRow[]=>list(v,"access").map(x=>{const r=rec(x);return{
  subject_id:s(r,"subject_id"),subject_name:s(r,"subject_name","Unknown user"),
  organization_role:s(r,"organization_role","—"),static_system_level:s(r,"static_system_level","—"),
  active_jit_level:typeof r.active_jit_level==="string"?r.active_jit_level:null,
  effective_system_level:s(r,"effective_system_level","—"),system_key_ready:b(r,"system_key_ready"),
  active_jit_expires_at:typeof r.active_jit_expires_at==="string"?r.active_jit_expires_at:null
}});
export const sessions=(v:unknown):SessionRow[]=>list(v,"sessions").map(x=>{const r=rec(x);return{
 id:s(r,"id"),
 session_id:s(r,"session_id"),subject_id:s(r,"subject_id"),
 subject_name:s(r,"subject_name","Unknown user"),created_at:s(r,"created_at"),
 last_seen_at:s(r,"last_seen_at"),expires_at:s(r,"expires_at"),
 revoked_at:typeof r.revoked_at==="string"?r.revoked_at:null,active:b(r,"active"),
 device_label:str(r,"device_label"),client_class:str(r,"client_class"),
 browser_family:str(r,"browser_family"),os_family:str(r,"os_family"),
 auth_method:str(r,"auth_method"),ip_address:str(r,"ip_address"),
 device_posture_id:str(r,"device_posture_id"),
 posture_trust_state:str(r,"posture_trust_state"),
 posture_platform:str(r,"posture_platform"),
 posture_last_verified_at:str(r,"posture_last_verified_at"),
 posture_recovery_class:str(r,"posture_recovery_class"),
 state:s(r,"state","UNKNOWN"),credential_label:str(r,"credential_label"),
 session_total:n(r,"session_total"),active_session_total:n(r,"active_session_total"),
 is_current:b(r,"is_current")
}});
export const recovery=(v:unknown):RecoveryRow[]=>list(v,"subjects").map(x=>{const r=rec(x);return{
  subject_id:s(r,"subject_id"),subject_name:s(r,"subject_name","Unknown user"),
  unlock_credentials:n(r,"unlock_credentials"),trust_groups:n(r,"trust_groups"),
  offline_recovery_ready:b(r,"offline_recovery_ready"),
  offline_recovery_verified_at:typeof r.offline_recovery_verified_at==="string"?r.offline_recovery_verified_at:null,
  recovery_state:s(r,"recovery_state","UNKNOWN"),below_unlock_minimum:b(r,"below_unlock_minimum"),
  below_trust_group_minimum:b(r,"below_trust_group_minimum")
}});
export const jitRequests=(v:unknown):JitRequest[]=>list(v,"pending").map(x=>{const r=rec(x);return{
  request_id:s(r,"request_id"),subject_name:s(r,"subject_name","Unknown user"),
  requested_level:s(r,"requested_level","—"),requested_at:s(r,"requested_at"),
  expires_requested_at:typeof r.expires_requested_at==="string"?r.expires_requested_at:null
}});
export const jitGrants=(v:unknown):JitGrant[]=>list(v,"active_grants").map(x=>{const r=rec(x);return{
  grant_id:s(r,"grant_id"),subject_name:s(r,"subject_name","Unknown user"),
  resource_type:s(r,"resource_type","—"),access_level:s(r,"access_level","—"),expires_at:s(r,"expires_at")
}});
export const audit=(v:unknown):AuditRow[]=>list(v,"events").map(x=>{const r=rec(x);return{
  id:s(r,"id"),occurred_at:s(r,"occurred_at"),event_type:s(r,"event_type","security.event"),
  resource_type:typeof r.resource_type==="string"?r.resource_type:null,
  resource_id:typeof r.resource_id==="string"?r.resource_id:null,
  outcome:s(r,"outcome","—"),severity:s(r,"severity","—")
}});
export const policies=(v:unknown):PolicyRow[]=>list(v,"policies").map(x=>{const r=rec(x);return{
  policy_key:s(r,"policy_key","Unnamed policy"),policy_version:r.policy_version as number|string??"—",
  enabled:b(r,"enabled"),config:r.config
}});
export const settings=(v:unknown):SettingRow[]=>list(v,"settings").map(x=>{const r=rec(x);return{
  setting_key:s(r,"setting_key","Unnamed setting"),setting_value:r.setting_value,
  source:s(r,"source","—"),mutable:b(r,"mutable")
}});
export function authorityStatus(v:unknown):AuthorityStatus{const r=rec(v);return{
  signed_in:typeof r.signed_in==="boolean"?r.signed_in:undefined,
  authority_unlocked:typeof r.authority_unlocked==="boolean"?r.authority_unlocked:undefined,
  expires_in_seconds:typeof r.expires_in_seconds==="number"?r.expires_in_seconds:undefined
}}
